import { ChangeDetectionStrategy,Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import {IrbAppEvents} from "@irb/app.events";
import {AppService} from "@irb/app.service";
import {UtilityService} from "@irb-common/services/utility.service";
import {DomSanitizer} from "@angular/platform-browser";

@Component({ standalone: false,
  selector: 'irb-dialog-finmason-train-sso',
  templateUrl: './dialog-finmason-train-sso.component.html',
  styleUrls: ['./dialog-finmason-train-sso.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class DialogFinmasonTrainSsoComponent implements OnInit {
  dialogTitle = 'Analyze Portfolio in FinMason';
  buttonTitle = 'Confirm Portfolio';
  leftButtonTitle = 'Cancel';
  trainStepsTitles = ['Review portfolio', 'Send to FinMason'];
  currentStepId = 0;
  loadPortfolio: boolean;
  loadModels: boolean;
  loadMMC: boolean;
  selectedPortfolios: Array<any>;
  finalPortfolio: Array<any> = [];
  selectedModels: Array<any> = [];
  finalModels: Array<any> = [];
  isUiTest = false;
  loadPortfolioError: any;
  loadModelsError: any = [];
  loadMMCError: any = [];
  hideNextButton = false;
  cancelButtonClass: string;
  sacAboutFinmasonUrl: any;

  constructor(public dialogRef: MatDialogRef<DialogFinmasonTrainSsoComponent>,
              @Inject(MAT_DIALOG_DATA) public dialogData: any,
              private ats: AnalyticsService,
              public as: AppService,
              private util: UtilityService,
              private sanitizer: DomSanitizer) {
    this.cancelButtonClass = 'btn-medium-secondary';
    this.loadPortfolio = this.dialogData.loadPortfolio;
    this.loadModels = this.dialogData.loadModels;
    this.loadMMC = this.dialogData.loadMMC;
    this.setDataAndTitles();
    this.getSACAboutFinmasonUrl();
  }

  setDataAndTitles() {
    if (this.loadPortfolio) {
      this.selectedPortfolios = this.dialogData.selectedPortfolios || [];
      this.selectedPortfolios = JSON.parse(JSON.stringify(this.selectedPortfolios));
      this.selectedPortfolios.map(portfolio => portfolio.securityModelName = portfolio.securityModelName ? portfolio.securityModelName : 'None');
    }

    this.loadModels = this.dialogData.loadModels;
    this.loadMMC = this.dialogData.loadMMC;
    if (this.loadModels || this.loadMMC) {
      this.selectedModels = this.dialogData.selectedModels || [];
      this.dialogTitle = 'Compare Models in FinMason';
      this.buttonTitle = 'Confirm Models';
      this.leftButtonTitle = 'Cancel';
      this.trainStepsTitles = ['Review models', 'Send to FinMason'];

      if (this.loadModels) {
        this.selectedModels = JSON.parse(JSON.stringify(this.selectedModels));
        this.selectedModels.map(model => model.type = model.type === 'Base' ? 'Security' : model.type);
      }
    }

    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    let url = this.buildValidationUrl();
    this.as.runThatCall(url).subscribe((res: any) => {
      const response = res && res.data && res.data.irebalResponse ? res.data.irebalResponse : res;
      this.setDataAfterValidation(response)
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.close();
      this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
        dType: 'NONE',
        dTitle: 'FinMason Unavailable',
        dProceedBtnLabel: '',
        msg: 'There’s a connection issue with iRebal and FinMason. Please try again later. If you continue to have issues, contact iRebal Support at (855) 640-2472.',
        onProceed: () => {
          this.ats.trackClickEvent("lc_finmason_err_cancel");
        },
        onCancel: () => {
          this.ats.trackClickEvent("lc_finmason_err_cancel");
        }
      });

    });

  }

  setDataAfterValidation(response: any) {
    if (this.loadPortfolio) {
      this.finalPortfolio = this.selectedPortfolios;
      this.loadPortfolioError = null;
      if (response && response.attributes && response.attributes.invalidPortfolio) {
        this.hideNextButton = true;
        this.leftButtonTitle = 'Cancel';
        this.cancelButtonClass = 'btn-medium-primary';
        this.loadPortfolioError = 'no values'; //Account zero or negative balance
        const invalidPortfolio: any = response.attributes.invalidPortfolio;
        const pId =  this.selectedPortfolios[0].portfolioId;
        if (invalidPortfolio[pId] && invalidPortfolio[pId].invalidPositions)
          this.loadPortfolioError = invalidPortfolio[pId].invalidPositions;
        if (invalidPortfolio[pId] && invalidPortfolio[pId].errorCode) {
          if (invalidPortfolio[pId].errorCode === 50002)
            this.loadPortfolioError = 'options_fi_bonds';
          if (invalidPortfolio[pId].errorCode === 50001) //Account with positions with negative market value
            this.loadPortfolioError = 'no values';
        }
      }
    }

    if (this.loadModels || this.loadMMC) {
      this.loadModelsError = [];
      this.loadMMCError = [];
      this.finalModels = [];
      if (response && response.attributes && response.attributes.invalidModels) {
        const invalidModels = response.attributes.invalidModels;
        this.selectedModels.forEach((model: any) => {
          if (this.loadModels) {
            if (invalidModels[model.modelId]) {
              model.invalid_positions = invalidModels[model.modelId].invalidPositions;
              this.loadModelsError.push(model);
            } else
              this.finalModels.push(model);
          }
          if (this.loadMMC) {
            if (invalidModels[model.modelMarketId]) {
              model.invalid_positions = invalidModels[model.modelMarketId].invalidPositions;
              this.loadMMCError.push(model);
            } else
              this.finalModels.push(model);
          }
        });

        if (!this.finalModels.length) {
          this.hideNextButton = true;
          this.leftButtonTitle = 'Cancel';
          this.cancelButtonClass = 'btn-medium-primary';
        }
      } else {
        this.finalModels = this.selectedModels;
      }
    }

  }

  ngOnInit(): void {
  }

  close() {
    if (this.currentStepId === 0) {
      if (this.loadPortfolioError)
        this.ats.trackClickEvent("lc_finmason_err_cancel");
      if (!this.finalModels.length) {
        if (this.loadModelsError.length || this.loadMMCError.length)
          this.ats.trackClickEvent("lc_finmason_err_cancel");
      }
    }

    this.dialogRef.close();
  }

  leftButtonClick() {
    if (this.currentStepId === 0) {
      this.close();
    } else {
      this.currentStepId--;
      this.leftButtonTitle = 'Cancel';
    }
  }

  nextStep() {
    this.ats.trackClickEvent("lc_finmason_confirm");
    this.currentStepId++;
    this.leftButtonTitle = 'Back';
  }

  continueToFinMason() {
    this.ats.trackClickEvent("lc_finmason_cont");
    let url = this.buildUrl();
    if (!this.isUiTest)
      url = window.location.origin + url
    window.open(url, "_blank");
    this.close();
  }

  buildUrl() {
    let url = '/finmason/';
    if (this.loadPortfolio) {
      url += 'portfolios/';
      url += this.selectedPortfolios[0].portfolioId;
    }

    if (this.loadModels) {
      let securityModelIds: Array<number> = [];
      let blendedMoldelIds: Array<number> = [];
      this.finalModels.forEach((model: any) => {
        if (model.type === 'Blended')
          blendedMoldelIds.push(model.modelId)
        else
          securityModelIds.push(model.modelId)
      });
      url += 'models?';
      if (securityModelIds.length) {
        url += 'securityModelIds=' + securityModelIds.join(',');
      }
      if (blendedMoldelIds.length) {
        if (securityModelIds.length)
          url += '&';

        url += 'blendedMoldelIds=' + blendedMoldelIds.join(',');
      }
    }

    if (this.loadMMC) {
      let mmcModelIds: Array<number> = [];
      let subscribedMMCModelIds: Array<number> = [];
      this.finalModels.forEach((model: any) => {
        if (model.isSubscribed)
          subscribedMMCModelIds.push(model.modelMarketId);
        else
          mmcModelIds.push(model.modelMarketId);
      });
      url += 'mmc-models?';
      if (mmcModelIds.length) {
        url += 'mmcModelIds=' + mmcModelIds.join(',');
        if (subscribedMMCModelIds.length)
          url += '&';
      }
      if (subscribedMMCModelIds.length) {
        url += 'subscribedMMCModelIds=' + subscribedMMCModelIds.join(',');
      }
    }
    return url;
  }

  deleteModel(deletedModelIndex: number) {
    this.finalModels.splice(deletedModelIndex, 1);
  }

  buildValidationUrl() {
    let url= '';
    if (this.loadPortfolio) {
      url += '/irebalone/portfolios/';
      url += this.selectedPortfolios[0].portfolioId;
      url += '/finmason/token?suppressToken=true';
    }

    if (this.loadModels) {
      let securityModelIds: Array<number> = [];
      let blendedMoldelIds: Array<number> = [];
      this.selectedModels.forEach((model: any) => {
        if (model.type === 'Blended')
          blendedMoldelIds.push(model.modelId)
        else
          securityModelIds.push(model.modelId)
      });
      url += '/irebalone/model/finmason/models/token?suppressToken=true';
      if (securityModelIds.length) {
        url += '&securityModelIds=' + securityModelIds.join(',');
      }
      if (blendedMoldelIds.length) {
        url += '&blendedMoldelIds=' + blendedMoldelIds.join(',');
      }
    }

    if (this.loadMMC) {
      const mmcModelIds: number[] = [];
      const subscribedMMCModelIds: number[] = [];
      this.selectedModels.forEach((model: any) => {
        if (model.isSubscribed) subscribedMMCModelIds.push(model.modelMarketId);
        else mmcModelIds.push(model.modelMarketId);
      });
      url += `/model-market-service/finmason/models/token?suppressToken=true`;
      if (mmcModelIds.length) {
        url += `&mmcModelIds=${mmcModelIds.join(',')}`;
      }
      if (subscribedMMCModelIds.length) {
        url += `&subscribedMMCModelIds=${subscribedMMCModelIds.join(',')}`;
      }
    }
    return url;
  }

  getSACAboutFinmasonUrl() {
    let url = 'https://' + this.util.getSACDomain();
    //url += '/SI2/ASK/Content/secure/ask/products-trading/model-market-center/how-to-work-with-model-market-center.html';
    url += '/SI2/ASK/Content/secure/ask/products-trading/finmason/introduction-to-finmason.html';
    // https://sac.schwabinstitutional.com/SI2/ASK/Content/secure/ask/products-trading/finmason/introduction-to-finmason.html
    this.sacAboutFinmasonUrl = this.sanitizer.bypassSecurityTrustUrl(url);
  }

  copyInvalidSecurities(invalidPositions: string) {
    navigator.clipboard.writeText(invalidPositions);
  }
}
